export const LogoDefault = () => {
    let src = require('../../assets/images/attractions/default/icon/no-image.webp');
    return src;
}